export const BADGE_COLOR_SCHEMES = {
  POPULAR: 'text-[#C08C17] bg-[#fcf6e8] border-[#ba9d59]',
  LAST_USED: 'text-[#008FDB] bg-[#E7F4FE] border-[#74C1ED]',
};

export const BADGE_TYPES = {
  POPULAR: 'POPULAR',
  LAST_USED: 'LAST_USED',
};
